/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:40:48
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-16 09:59:36
 * @FilePath: \monitor\src\language\index.js
 * @Description: 
 */
import User from "./user/index"; //用户模块翻译文件引入
import Data from "./data/index"; //用户模块翻译文件引入
import Report from "./report/index"; //用户模块翻译文件引入
import Project from "./project/index"; //用户模块翻译文件引入
const CN = {
  Language: {
    type: "中文"
  },
  User: User.CN,
  Data: Data.CN,
  Report: Report.CN,
  Project: Project.CN,
};
const EN = {
  Language: {
    type: "English"
  },
  User: User.EN,
  Data: Data.EN,
  Report: Report.EN,
  Project: Project.EN,
};
export default {
  CN,
  EN
};



// WEBPACK FOOTER //
// ./src/language/index.js